/**
 * 관측 창 길이 — 화면 문구가 **날짜를 박아 두지 않게** 한다.
 *
 * 「관측 창 23일」이라고 적어 둔 문구가 68일째에도 그대로 남아 있었다. 수집은 매일
 * 늘어나므로 길이를 말하는 문장은 매니페스트에서 읽어야 한다.
 */

import { useQuery } from '@tanstack/react-query'

import { fetchPlain } from './api'
import type { ManifestData } from './types'

/** 사업자 비교가능 판정의 관측 창 기준 (§3.7) */
export const WINDOW_MIN_DAYS = 28

export function useObservationDays(): number | null {
  // App 셸과 같은 키 — 캐시를 함께 쓴다
  const { data } = useQuery({
    queryKey: ['meta', 'manifest'],
    queryFn: ({ signal }) => fetchPlain<ManifestData>('/meta/manifest', signal),
    staleTime: 60 * 1000,
    retry: 1,
  })
  const first = data?.input_range.first_observed_at
  const last = data?.input_range.last_observed_at
  if (!first || !last) return null
  return Math.round((Date.parse(last) - Date.parse(first)) / 86_400_000)
}

/** 판정 보류 주석 — 창이 기준을 넘었는지에 따라 말이 달라진다 */
export function pendingNote(windowDays: number | null): string {
  if (windowDays == null) return ''
  return windowDays < WINDOW_MIN_DAYS
    ? `지금은 관측이 ${Math.round(windowDays)}일뿐이라 대부분이 보류인 것이 정상입니다.`
    : `관측 창이 ${Math.round(windowDays)}일로 기준을 넘었으므로 보류는 없습니다 — 제외의 대부분은 NA·STALE 20% 기준 때문입니다(데이터 품질 화면의 임계 민감도 참조).`
}
